import { render, staticRenderFns } from "./AdminDashNews.vue?vue&type=template&id=4379b938&scoped=true"
import script from "./AdminDashNews.vue?vue&type=script&lang=js"
export * from "./AdminDashNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4379b938",
  null
  
)

export default component.exports